import {
  TextInput,
  PasswordInput,
  Checkbox,
  Anchor,
  Paper,
  Title,
  Text,
  Container,
  Group,
  Button,
  LoadingOverlay,
  Box,
  Flex,
  PinInput,
  Grid,
  GridCol,
  ActionIcon,
} from "@mantine/core";
import classes from "./AuthenticationTitle.module.css";
import {
  readLocalStorageValue,
  useDisclosure,
  useLocalStorage,
  useOs,
} from "@mantine/hooks";
import { hasLength, isEmail, useForm } from "@mantine/form";
import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconBrandTelegram,
  IconHttpPost,
  IconLock,
  IconLockShare,
  IconMailOpened,
  IconUser,
} from "@tabler/icons-react";
import style from "./AuthenticationTitle.module.css";
import { LoginModel } from "../../../../model/LoginModel";
import { AuthProvider } from "../../../helper/IAuthProvider";
import { isNullOrEmpty } from "../../../extension/StringExtension";
import { NotificationExtension } from "../../../extension/NotificationExtension";
import { repositorySign } from "../../../_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";

interface UserCredentials {
  userName: string;
  pass: string;
  rePass: string;
  code: string;
}

export function AuthenticationTitle() {
  //#region  state
  const entity = {
    userName: "",
    pass: "",
    rePass: "",
    code: "",
  };
  const form = useForm<UserCredentials>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      userName: (value) =>
        value.length < 5 || value.length > 50
          ? "Tên đăng nhập phải từ 5-50 kí tự!"
          : null,
      pass: hasLength(
        { min: 6, max: 19 },
        "Mật khẩu phải từ 6 và nhỏ hơn 20 kí tự!"
      ),
      rePass: (value, values) => {
        if (hasLength({ min: 6, max: 19 })(value)) {
          return "Mật khẩu phải từ 6 và nhỏ hơn 20 kí tự!";
        }
        if (value !== values.pass) {
          return "Mật khẩu không khớp!";
        }
        return null;
      },
      code: (value) => value.length < 6 || value.length > 6,
    },
  });
  const navigate = useNavigate();

  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [visible1, setvisible1] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callbackParam = queryParams.get("callback");
  const [value, setValue] = useLocalStorage({
    key: "user-login",
    defaultValue: false,
  });
  const [locationVC, setLocation] = useState("");

  //#endregion
  function success(position: { coords: { latitude: any; longitude: any } }) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLocation("latitude: " + latitude + "-" + " longitude: " + longitude);
  }

  function error1() {
    console.log("Unable to retrieve your location");
  }
  //#region  auth
  const isAuthenticated = AuthProvider.isAuthenticated();
  const handleLogin = async (dataSubmit: UserCredentials) => {
    setvisible1(true);
    const type = form.getValues().userName;
    if (type) {
      const response = await repositorySign.post<
        MessageResponse<UserCredentials>
      >("/api/v1/Auth/repass", dataSubmit);
      if (response && response.success) {
        NotificationExtension.Success("Đặt lại mật khẩu thành công");
      } else {
        NotificationExtension.Fails("Đặt mật khẩu thất bại!");
      }
    }
    setvisible1(false);
  };

  const fetchDatacode = async () => {
    const type = form.getValues().userName;
    if (type) {
      const response = await repositorySign.get<MessageResponse<string>>(
        `/api/v1/Auth/code?userName=${type}`
      );
      if (response?.httpStatusCode === 200)
        if (response && response.success) {
          NotificationExtension.Success(
            "Mã xác minh đã được gửi tới email của bạn"
          );
        } else {
          NotificationExtension.Fails("Quá trình gửi mã xác minh thất bại !");
        }
    }
  };

  useEffect(() => {
    if (isAuthenticated === true) {
      navigate(callbackParam ?? "/");
    }
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error1);
    } else {
      console.log("Geolocation not supported");
    }
  }, []);
  return (
    <>
      <LoadingOverlay
        visible={visible1}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Flex mb={40} direction="column">
        <Title c="#342e79" fw={500} order={3}>
          Quên mật khẩu?
        </Title>
        <Text c="#8e8e8e" fw="400" size="sm">
          Khôi phục mật khẩu của bạn
        </Text>
      </Flex>
      <Box
        component="form"
        m={0}
        p={0}
        className={style.form}
        onSubmit={form.onSubmit(async (e: UserCredentials) => {
          await handleLogin(e);
        })}
      >
        <Paper pb={50} bg={"transparent"}>
          <TextInput
            radius="xl"
            label={
              <Text c="#342e79" mb={5} size="sm" fw="bold">
                Nhập tài khoản
              </Text>
            }
            leftSection={<IconUser size={20} />}
            rightSection={
              <ActionIcon
                onClick={async () => await fetchDatacode()}
                size="lg"
                variant="filled"
                radius="xl"
              >
                <IconBrandTelegram size={20} />
              </ActionIcon>
            }
            size="lg"
            placeholder="Vui lòng nhập tài khoản"
            mt="md"
            {...form.getInputProps("userName")}
          />
          <Box mt={16}>
            <Text fw={700} size="sm" c="#342e79">
              Vui lòng nhập mã OTP
            </Text>
            <PinInput
              mt={5}
              length={6}
              placeholder="0"
              size="lg"
              type="number"
              {...form.getInputProps("code")}
            />
          </Box>
          <PasswordInput
            radius="xl"
            label={
              <Text c="#342e79" mb={5} size="sm" fw="bold">
                Mật khẩu mới
              </Text>
            }
            leftSection={<IconLock size={20} />}
            size="lg"
            placeholder="Mật khẩu của bạn"
            mt="md"
            {...form.getInputProps("pass")}
          />
          <PasswordInput
            radius="xl"
            label={
              <Text c="#342e79" mb={5} size="sm" fw="bold">
                Nhập lại mật khẩu
              </Text>
            }
            leftSection={<IconLockShare size={20} />}
            size="lg"
            placeholder="Mật khẩu của bạn"
            mt="md"
            {...form.getInputProps("rePass")}
          />
          <Group justify="space-between" gap={10}>
            <Button
              leftSection={<IconArrowNarrowLeft color="#000" size={24} />}
              mt="md"
              bg="#f8f8f8"
              className={style.button_submit}
              size="lg"
              w={170}
              radius="xl"
              onClick={() => navigate("/auth/login")}
            >
              <Text c={"#000"} fw={500} size="lg">
                Trở lại
              </Text>
            </Button>
            <Button
              rightSection={<IconArrowNarrowRight color="#fff" size={24} />}
              type="submit"
              bg="#342e79"
              mt="md"
              className={style.button_submit}
              size="lg"
              radius="xl"
            >
              <Text c={"#fff"} fw={500} size="lg">
                Đặt lại mật khẩu
              </Text>
            </Button>
          </Group>
        </Paper>
        {/* <Group justify="end">
          <Text size="xs">
            <Flex gap={4}>
              Copyright © 2024{" "}
              <Text fw={600} c="#000">
                Hacom.
              </Text>{" "}
              All rights reserved.
            </Flex>
          </Text>
        </Group> */}
      </Box>
    </>
  );
}
